export type ResponseHandlerState = {
  [name in ResponseHandlerName]: ResponseHandlerData;
};

export interface ResponseHandlerData {
  loading: boolean;
  error: string;
}

export enum ResponseHandlerName {
  // Auth
  OnLoad = "onLoad",
  SignOut = "signOut",
  SignIn = "signIn",
  GetMetricsAndIndexes = "getMetricsAndIndexes",
}
